import { useState, useCallback } from 'react';

export const useLoadingState = () => {
    const [showLoading, setShowLoading] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);
    const [progress, setProgress] = useState(0);

    const reset = useCallback(() => {
        setShowLoading(true);
        setProgress(0);
        setFadeOut(false);
    }, []);

    return {
        showLoading,
        fadeOut,
        progress,
        setShowLoading,
        setProgress,
        setFadeOut,
        reset
    };
}; 